import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { excludeMileagePath, replaceHyphensWithSpace } from 'Utilities/breadcrumbs';
import { classNamePropType } from 'Utilities/propTypes';

import { formatURLToRemoveWP } from '../../contentPages/wordPressPages/utilities/WordpressHelpers';

import styles from './Breadcrumbs.scss';

const Breadcrumbs = ({
  className, leftAlign, list, onYellow,
}) => {
  const location = useLocation();
  let { pathname } = location;

  pathname = formatURLToRemoveWP(pathname) === '/blog' ? 'blog' : pathname; // TODO - delete `formatURLToRemoveWP` after testing

  const links = useMemo(() => {
    if (list.length) {
      return list;
    }

    const parts = excludeMileagePath(pathname);

    if (parts.length > 1) {
      let prevPath = '';
      const crumbs = parts.map((it) => {
        prevPath += `/${it}`;
        return {
          label: replaceHyphensWithSpace(it),
          route: prevPath,
        };
      });
      crumbs.pop();
      crumbs.unshift({
        label: 'Home',
        route: '/',
      });

      return crumbs;
    }

    return [];
  }, [pathname, list]);

  return (
    <nav className={cx(styles.crumbs, className, {
      [styles.leftAlign]: leftAlign,
      [styles.hidden]: links.length === 0,
    })}
    >
      {
        links.map(({ label, route }, i) => (
          <React.Fragment key={label}>
            <Link className={cx(styles.link, { [styles.onYellow]: onYellow })} to={route}>
              <span className={styles.inner}>{label}</span>
            </Link>
            {
              (links.length - 1 !== i) ? (
                <span className={styles.divider}>/</span>
              ) : (null)
            }
          </React.Fragment>
        ))
      }
    </nav>
  );
};

Breadcrumbs.defaultProps = {
  className: null,
  leftAlign: false,
  list: [],
  onYellow: false,
};

Breadcrumbs.propTypes = {
  className: classNamePropType,
  leftAlign: PropTypes.bool,
  list: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    route: PropTypes.string,
  })),
  onYellow: PropTypes.bool,
};

export default Breadcrumbs;
